<template>
  <div class="container-fluid">
    <div class="row">
      <!-- Left Panel -->
      <div class="col-md-8 item-left">
        <!-- <div id="Logo">
          <img src="/static/img/logo.png" id="msd-logo">
        </div> -->
      </div>
      <!-- End of Left Panel -->

      <!-- Right Panel -->
      <div class="col-md-4 item-right">
        <div class="form-container" v-if="showLogin">
          <div id="Logo">
            <!-- <img src="/static/img/logo.png" id="msd-logo"> -->
          </div>

          <h2>Login</h2>

          <p>Please enter your email and password to login</p>

          <h5 v-if="ErrorMessage == true" class="error">
            Please enter the fields marked *
          </h5>

          <div class="form-group">
            <input
              type="email"
              class="form-control"
              id="inputEmail"
              v-model="username"
              placeholder="Enter Email"
              required
            />
          </div>

          <div class="form-group">
            <input
              type="password"
              class="form-control"
              id="inputPassword"
              v-model="password"
              placeholder="Password"
              required
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            id="LoginButton"
            v-on:click="UserLogin()"
          >
            Login
          </button>
          <!-- <button type="submit" class="btn btn-primary btn-block" id="LoginButton" v-on:click="SignUp()">Sign Up</button> -->

          <transition name="fade">
            <h5 v-if="LoginError == true" class="error">
              Sorry, please check the above details and try again
            </h5>
          </transition>
        </div>

        <div class="form-container" v-if="!showLogin">
          <div id="Logo">
            <!-- <img src="/static/img/logo.png" id="msd-logo"> -->
          </div>

          <h2>Sign up</h2>

          <div class="form-group">
            <input
              type="text"
              class="form-control"
              id="inputEmail"
              v-model="userModel.name"
              placeholder="Enter Name"
              required
            />
          </div>
          <div class="form-group">
            <input
              type="email"
              class="form-control"
              id="inputEmail"
              v-model="userModel.email"
              placeholder="Enter Email"
              required
            />
          </div>
          <div class="form-group">
            <input
              type="tel"
              class="form-control"
              id="inputEmail"
              v-model="userModel.mobile"
              placeholder="Enter Mobile"
              required
            />
          </div>

          <div class="form-group">
            <input
              type="password"
              class="form-control"
              id="inputPassword"
              v-model="userModel.password"
              placeholder="Password"
              required
            />
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block"
            id="LoginButton"
            v-on:click="UserSignUp()"
          >
            Sign up
          </button>

          <transition name="fade">
            <h5 v-if="LoginError == true" class="error">
              Sorry, please check the above details and try again
            </h5>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import { globalStore } from "../main.js";
import Swal from "sweetalert2";
export default {
  name: "Login",
  data(router) {
    return {
      username: "",
      password: "",
      ErrorMessage: false,
      LoginError: false,
      showLogin: true,
      userModel: {
        name: "",
        mobile: "",
        email: "",
        password: "",
      },
    };
  },
  methods: {
    SignUp() {
      this.showLogin = false;
    },
    UserSignUp() {
      console.log("model", this.userModel);
      axios
        .post(globalStore.url + `api/add-user`, this.userModel)
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Your account has been created successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          this.showLogin = true;
        })
        .catch((e) => {
          console.log("err creating acc", e);
          Swal.fire("Oops...", "Something went wrong!", "error");
        });
    },
    UserLogin() {
      console.log("user login");
      // if (this.username == 'admin@admin.com' && this.password == '123456') {
      //   this.$router.push('/')
      // }
      // else{
      //   this.LoginError = true;
      // }

      if (this.username != "" && this.password != "") {
        console.log(this.username);
        console.log(this.password);

        // localStorage.setItem("AdminId", "Admin")
        // localStorage.setItem("AdminObject", "AdminObject")
        // this.$router.push('/')
        console.log("URL: " + globalStore.url);
        axios
          .post(globalStore.url + `auth/admin-login`, {
            email: this.username,
            password: this.password,
          })
          .then((res) => {
            console.log(res);
            let token = {
              headers: {
                authtoken: res.data.data.token,
              },
            };
            localStorage.setItem("user", JSON.stringify(res.data.data));
            localStorage.setItem("token", JSON.stringify(token));
            this.$router.push("/");
          })
          .catch((e) => {
            // this.errors.push(e)
            console.log("error is :" + e);
            this.LoginError = true;
            this.ErrorMessage = false;
          });
      } else {
        this.ErrorMessage = true;
      }
    },
  },
};
</script>

<style>
#msd-logo {
  width: 100px;
}

.container-fluid,
.item-left,
.item-right {
  height: 100vh;
}

.item-left {
  /* border: 1px solid red; */
  background-color: #039be5;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  background-image: url("/static/img/bg-3.jpg");
  /* background-image: linear-gradient( rgba(112,112,112, 0.7), rgba(112,112,112, 0.7)), url('/static/img/bg-2.jpg'); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

#Logo {
  align-self: center;
  text-align: center;
}

.item-right {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
}

.form-container {
  align-self: center;
  /* padding: 2em; */
  /* border: 1px solid #000000; */
  border-radius: 1em;
  padding: 1em;
  width: 80%;
  text-align: center;
  color: #808080;
}

#inputEmail,
#inputPassword {
  border-radius: 2em;
}

#LoginButton {
  background-color: #039be5;
  border: 1px solid #039be5;
  border-radius: 2em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/* ----------------------- Old styling --------------------------- */

/* h3 {
  color: white;
} */

/* #LoginForm{ background-image:url("https://hdwallsource.com/img/2014/9/blur-26347-27038-hd-wallpapers.jpg");  background-position:center; background-size:cover;} */
.LoginForm {
  background-color: #5b7fc8;
  height: 55em;
  padding-top: 5%;
}

.form-heading {
  color: #fff;
  font-size: 23px;
}

.panel h2 {
  color: #444444;
  font-size: 18px;
  margin: 0 0 8px 0;
}

.panel p {
  color: #777777;
  font-size: 14px;
  margin-bottom: 30px;
  line-height: 24px;
}

.login-form .form-control {
  background: #f7f7f7 none repeat scroll 0 0;
  border: 1px solid #d4d4d4;
  border-radius: 4px;
  font-size: 14px;
  height: 50px;
  line-height: 50px;
}

.error {
  color: red;
  font-size: 15px;
  font-weight: 15px;
}

.main-div {
  background: #5b7fc8 none repeat scroll 0 0;
  border-radius: 2px;
  margin: 10px auto 30px;
  max-width: 38%;
  padding: 50px 70px 70px 71px;
}

.login-form .form-group {
  margin-bottom: 10px;
}

.login-form {
  text-align: center;
}

.forgot a {
  color: #777777;
  font-size: 14px;
  text-decoration: underline;
}

.login-form .btn.btn-primary {
  background: #f0ad4e none repeat scroll 0 0;
  border-color: #f0ad4e;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
}

.forgot {
  text-align: left;
  margin-bottom: 30px;
}

.botto-text {
  color: #ffffff;
  font-size: 14px;
  margin: auto;
}

.login-form .btn.btn-primary.reset {
  background: #ff9900 none repeat scroll 0 0;
}

.back {
  text-align: left;
  margin-top: 10px;
}

.back a {
  color: #444444;
  font-size: 13px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// Login.vue?16260d0d